import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ICustomEditorService = ( createDecorator('customEditorService'));
export { ICustomEditorService };
